import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { browserHistory as history } from 'react-router';
import moment from "moment";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Segmented from "rc-segmented";

import HelpOutline from '@material-ui/icons/HelpOutline';
import ExportIcon from '../../../../icons/ExportIcon';
import SurveyCountSummery from '../../../../components/v3/SurveyActivityV3/SurveyCountSummery';
import SurveyActivityV3AgentScreen from '../agents/SurveyActivityV3AgentScreen';
import TeamsCompareAndOverTimeGraphs from './graphs/TeamsCompareAndOverTimeGraphs';
import TicketsListModal from '../../../../components/v3/utils/Tickets/TicketsListModal';

import SelectTable from '../../../../components/v3/CalibrationScreenV3/SelectTable';
import PopupCustomized from '../../../../components/PopupCustomized';

//import DateRangePicker from '../../../../components/DateRangePicker/DateRangePicker';
import DateRangePicker from '../../../../components/v3/DateRangePicker/DateRangePicker';

import PieChart from '../../../../components/v3/Graphs/Calibration/PieChart';

import { pageLoaded } from '../../../../utils';
import { dateTimeFormat, colors, filterType, clientIdNumber, timePeriodicityOptions } from '../../../../constants';
import { ZRole, SurveyType } from '../../../../generated';
import {
    isDefined, getOnlyUnique, getPieChartColorSet, getScoreOnSurveyQuestion, arrayIsNotEmpty, cloneArray, getSelectedNode,
    getSelectedIndividualNode, getPieChartColorSetByPerformanceIdAndValue
} from '../../../../utils';

import {
    updateProps,
    loadSurveyActivityV3ManagerScreen,
    loadSurveyActivityBasicData,

    loadAllInteractions,
    loadResponseBreakdown,
    loadInteractionsReport,
    loadCustomerInteractionsReport,
    loadCustomerInteractionsReportBySurveyDate
} from '../SurveyActivityScreenActions';
import LoadingControl from '../../../../components/LoadingControl';

class SurveyActivityV3ManagerScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTimePeriodicity: "Daily",
            showTicketsListPopup: false,
            showSelectAgentPopup: false,
            showSelectTeamPopup: false,
            showSelectReasonsForContactPopup: false,
            showSelectChannelPopup: false,
            selectedTeam: undefined,
            selectedReasonForContact: undefined,
            selectedChannel: undefined,
            selectedSurveyTypeId: SurveyType.Calibrator,
            selectedFilters: [],

            timezoneOffset: 0,

            mouseClickX: 100,
            mouseClickY: 100
        };

        this.showTeamComparisonHelpPopup = this.showTeamComparisonHelpPopup.bind(this);
        this.closeTeamComparisonHelpPopup = this.closeTeamComparisonHelpPopup.bind(this);

        this.getSelectAgentPopup = this.getSelectAgentPopup.bind(this);
        this.getSelectTeamPopup = this.getSelectTeamPopup.bind(this);
        this.getSelectReasonForContactPopup = this.getSelectReasonForContactPopup.bind(this);
        this.getSelectChannelPopup = this.getSelectChannelPopup.bind(this);

        this.getSelectedAgentNode = this.getSelectedAgentNode.bind(this);
        this.getSelectedTeamsNode = this.getSelectedTeamsNode.bind(this);
        this.getSelectedReasonForContactNode = this.getSelectedReasonForContactNode.bind(this);
        this.getSelectedChannelNode = this.getSelectedChannelNode.bind(this);

        this.removeReasonForContact = this.removeReasonForContact.bind(this);
        this.removeChannel = this.removeChannel.bind(this);
        this.removeTeam = this.removeTeam.bind(this);
        this.removeAgent = this.removeAgent.bind(this);

        this.showSelectAgentPopup = this.showSelectAgentPopup.bind(this);
        this.hideSelectAgentPopup = this.hideSelectAgentPopup.bind(this);

        this.showSelectTeamPopup = this.showSelectTeamPopup.bind(this);
        this.hideSelectTeamPopup = this.hideSelectTeamPopup.bind(this);

        this.showSelectReasonsForContactPopup = this.showSelectReasonsForContactPopup.bind(this);
        this.hideSelectReasonsForContactPopup = this.hideSelectReasonsForContactPopup.bind(this);

        this.showSelectChannelPopup = this.showSelectChannelPopup.bind(this);
        this.hideSelectChannelPopup = this.hideSelectChannelPopup.bind(this);

        this.getInteractionsReport = this.getInteractionsReport.bind(this);

        this.closeTicketsListPopup = this.closeTicketsListPopup.bind(this);
        this.showTicketsListPopup = this.showTicketsListPopup.bind(this);

        this.setSelectedSurveyTypeId = this.setSelectedSurveyTypeId.bind(this);

        this.onSelectNewTimeRange = this.onSelectNewTimeRange.bind(this);
        this.onSelectNewTimeRangeForTickets = this.onSelectNewTimeRangeForTickets.bind(this);

        this.getSurveyCountSummaryNode = this.getSurveyCountSummaryNode.bind(this);
        this.getBreakdownNode = this.getBreakdownNode.bind(this);
        this.getRfcBreakdownNode = this.getRfcBreakdownNode.bind(this);
        this.getChannelBreakdownNode = this.getChannelBreakdownNode.bind(this);
        this.getCustomerInteractionsReport = this.getCustomerInteractionsReport.bind(this);
        this.getCustomerInteractionsReportBySurveyDate = this.getCustomerInteractionsReportBySurveyDate.bind(this);
    }

    componentDidMount() {
        pageLoaded('Survey Activity');

        const fromDate = moment().startOf('day').subtract(7, 'd').format(dateTimeFormat);
        const toDate = moment().endOf('day').format(dateTimeFormat);

        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));
        this.props.dispatch(loadSurveyActivityV3ManagerScreen(fromDate, toDate, this.state.selectedTimePeriodicity,
            undefined, undefined, SurveyType.Calibrator));
        this.props.dispatch(loadSurveyActivityBasicData());
    }

    showTeamComparisonHelpPopup(e) {
        this.setState({ showTeamComparisonHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeTeamComparisonHelpPopup() {
        this.setState({ showTeamComparisonHelpPopup: false });
    }

    showTicketsListPopup() {
        this.setState({ showTicketsListPopup: true });
    }

    closeTicketsListPopup() {
        this.setState({ showTicketsListPopup: false });
    }

    onSelectNewTimeRangeForTickets(fromDate, toDate) {
        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));

        this.props.dispatch(updateProps({ allInteractions: undefined }));
        this.props.dispatch(loadAllInteractions(fromDate, toDate));
    }

    onSelectNewTimeRange(fromDate, toDate) {
        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));
    }

    getSelectFilterPopup = () => {
        const
            {
                domainValues
            } = this.props;

        if (!arrayIsNotEmpty(domainValues))
            return;

        const domainObject = domainValues.find(f => f.domainId === this.state.filterIdToShow)
        const newArray = domainObject.domainValues.map(obj => {
            return {
                id: obj.domainValueId,
                name: obj.domainValueName,
                domainId: domainObject.domainId
            };
        });
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={true}
                    title="Select "
                    searchPlaceHolder="Search..."
                    options={newArray}
                    onClose={this.hideFilterPopup} />
            </div>
        </div>);
    }

    hideFilterPopup = (newFilters) => {
        this.setState({ showSelectFilterPopup: false });

        const filteredNewFilters = newFilters.filter(newFilter => {
            return !this.state.selectedFilters.some(selectedFilter => selectedFilter.id === newFilter.id);
        });

        this.setState(prevState => ({
            selectedFilters: [...prevState.selectedFilters, ...filteredNewFilters]
        }));
    }

    removeFilter = (domainId) => {
        const updatedFilters = this.state.selectedFilters.filter(filter => filter.id !== domainId);

        this.setState({ selectedFilters: updatedFilters });
    }

    getFilters = () => {
        const
            {
                currentUser,
                domainValues
            } = this.props;
        if (!isDefined(currentUser) || !arrayIsNotEmpty(domainValues))
            return;

        const filters = domainValues.map(f => <div key={f.domainId}
            className="v3-button" style={{ display: 'inline-flex', margin: '0 10px 2px 0' }}
            onClick={() => this.setState({ showSelectFilterPopup: true, filterIdToShow: f.domainId })}>
            + {f.domainName}
        </div>);

        const selectFilterPopup = this.state.showSelectFilterPopup ? this.getSelectFilterPopup() : undefined;

        const selectedFilters = this.state.selectedFilters.map(obj => getSelectedIndividualNode(domainValues, obj, this.removeFilter));

        const applyFilterButton = (
            <div className="v3-button" style={{ display: 'inline-flex', margin: '0 10px 2px 0', background: '#98DDE1' }} onClick={this.onApplyFilters}  >
                Apply Filter
            </div>);

        return (<>
            <div style={{ borderTop: '3px solid #E5E5E5', padding: '10px 0 0 10px' }} className="flex flex-space-between align-items-flex-start">
                <div style={{ minWidth: 'max-content' }}>
                    <DateRangePicker
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        onClose={this.onSelectNewTimeRange} />
                </div>
                <div>
                    <div>
                        {filters}
                        {applyFilterButton}
                    </div>
                </div >
            </div>
            <div className="flex flex-space-between">
                <div style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', margin: '10px 0 10px 10px' }}>
                    {selectedFilters}
                    <div style={{ marginBottom: '1px' }}>
                        {selectFilterPopup}
                    </div>

                </div>
            </div>
        </>);
    }

    showSelectAgentPopup() {
        this.setState({ showSelectAgentPopup: true });
    }

    hideSelectAgentPopup(selectedAgents) {
        this.setState({ showSelectAgentPopup: false });

        if (selectedAgents && selectedAgents.length == 0) {
            this.setState({ selectedTeam: undefined });
        }
        else {
            this.setState({ selectedAgent: selectedAgents });
        }
    }

    showSelectTeamPopup() {
        this.setState({ showSelectTeamPopup: true });
    }

    hideSelectTeamPopup(selectedTeams) {
        this.setState({ showSelectTeamPopup: false });

        if (selectedTeams && selectedTeams.length == 0) {
            this.setState({ selectedTeam: undefined });
        }
        else {
            this.setState({ selectedTeam: selectedTeams });
        }
    }

    showSelectReasonsForContactPopup() {
        this.setState({ showSelectReasonsForContactPopup: true });
    }

    hideSelectReasonsForContactPopup = (selectedReasonForContact) => {
        this.setState({ showSelectReasonsForContactPopup: false });

        if (selectedReasonForContact && selectedReasonForContact.length == 0) {
            this.setState({ selectedReasonForContact: undefined });
        }
        else {
            this.setState({ selectedReasonForContact: selectedReasonForContact });
        }
    }

    showSelectChannelPopup() {
        this.setState({ showSelectChannelPopup: true });
    }

    hideSelectChannelPopup = (selectedChannel) => {
        this.setState({ showSelectChannelPopup: false });

        if (selectedChannel && selectedChannel.length == 0) {
            this.setState({ selectedChannel: undefined });
        }
        else {
            this.setState({ selectedChannel: selectedChannel });
        }
    }

    getSelectedAgentNode() {
        if (!this.state.selectedAgent)
            return undefined;

        return getSelectedNode(filterType.agent, this.state.selectedAgent, this.removeAgent);
    }

    getSelectedTeamsNode() {
        if (!this.state.selectedTeam)
            return undefined;

        return getSelectedNode(filterType.team, this.state.selectedTeam, this.removeTeam);
    }

    getSelectedReasonForContactNode() {
        if (!this.state.selectedReasonForContact)
            return undefined;

        return getSelectedNode(filterType.reasonForContact, this.state.selectedReasonForContact, this.removeReasonForContact);
    }

    getSelectedChannelNode() {
        if (!this.state.selectedChannel)
            return undefined;

        return getSelectedNode(filterType.channel, this.state.selectedChannel, this.removeChannel);
    }

    removeTeam() {
        this.setState({ selectedTeam: undefined });
    }

    removeAgent() {
        this.setState({ selectedAgent: undefined });
    }


    removeReasonForContact() {
        this.setState({ selectedReasonForContact: undefined });
    }

    removeChannel() {
        this.setState({ selectedChannel: undefined });
    }

    getSelectReasonForContactPopup = () => {
        const
            {
                reasonsForContact,
            } = this.props;

        if (!reasonsForContact)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectReasonForContact">
                <SelectTable
                    selectMultiple={true}
                    title="Select a reason for contact:"
                    searchPlaceHolder="Search..."
                    options={reasonsForContact}
                    onClose={this.hideSelectReasonsForContactPopup} />
            </div>
        </div>);
    }

    getSelectChannelPopup = () => {
        const
            {
                channels,
            } = this.props;

        if (!channels)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectReasonForContact">
                <SelectTable
                    selectMultiple={true}
                    title="Select a channel:"
                    searchPlaceHolder="Search..."
                    options={channels}
                    onClose={this.hideSelectChannelPopup} />
            </div>
        </div>);
    }

    getSelectTeamPopup = () => {
        const
            {
                userTeamsStats,
            } = this.props;

        if (!isDefined(userTeamsStats))
            return;

        //To change

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={true}
                    title="Select team"
                    searchPlaceHolder="Search..."
                    options={userTeamsStats}
                    onClose={this.hideSelectTeamPopup} />
            </div>
        </div>);
    }

    getSelectAgentPopup = () => {
        const
            {
                usersStats,
            } = this.props;

        if (!isDefined(usersStats))
            return;

        //To change
        const agents = usersStats.filter(u => u.roleId == ZRole.Agent);
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={false}
                    title="Select agent"
                    searchPlaceHolder="Search..."
                    options={agents}
                    onClose={this.hideSelectAgentPopup} />
            </div>
        </div>);
    }

    getSurveyCountSummaryNode() {
        const
            {
                currentUser,
                ticketCountOverTimeStats,
            } = this.props;
        if (!ticketCountOverTimeStats) {
            return (<div className="system-dashboard-jibe-border SurveyCountSummery-main"
                style={{
                    boxShadow: 'none', padding: '24px 24px 0 24px',
                    backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})`
                }}>
                <div className="flex-container" style={{ minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8', }}>
                    <div className="title-primary-400-24-28">
                        Survey Count
                    </div>
                    <div className="v3-button agent-view-interactions"
                        style={{ background: '#E6F7F8', padding: '13px 17px' }}
                        onClick={this.showTicketsListPopup}>
                        See All Tickets
                    </div>
                </div>
                <div style={{ minHeight: '94px' }}>
                    <div style={{ backgroundColor: 'rgb(252,252,255)' }} >
                        <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="250" />
                    </div>
                </div>

            </div >)
        }

        if (isDefined(ticketCountOverTimeStats)) {

            const ticketCountAll = ticketCountOverTimeStats.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.tickets;
            }, 0);

            let agentSurveyCountAll = ticketCountOverTimeStats.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.agentSurveys;
            }, 0);
            let customerSurveyCountAll = ticketCountOverTimeStats.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.customerSurveys;
            }, 0);

            let surveySummery1;

            if (currentUser.ClientId === clientIdNumber.TML) {
                surveySummery1 = [
                    {
                        text: "Agent Predictions",
                        barColor: colors.primary200,
                        number: agentSurveyCountAll,
                    },
                    {
                        text: "Customer Survey",
                        barColor: colors.fourth200,
                        number: customerSurveyCountAll,
                        rate: agentSurveyCountAll > 0 ? `(Response Rate: ${((customerSurveyCountAll * 100) / agentSurveyCountAll).toFixed(2)}%)` : undefined
                    },
                ];
            }
            else {
                surveySummery1 = [
                    {
                        text: "All Tickets",
                        barColor: colors.secandary200,
                        number: ticketCountAll,
                    },
                    {
                        text: "Agent Predictions",
                        barColor: colors.primary200,
                        number: agentSurveyCountAll,
                        rate: ticketCountAll > 0 ? `(Compliance: ${Math.round((agentSurveyCountAll * 100) / ticketCountAll)}%)` : undefined
                    },
                    {
                        text: "Customer Survey",
                        barColor: colors.fourth200,
                        number: customerSurveyCountAll,
                        rate: ticketCountAll > 0 ? `(Response Rate: ${Math.round((customerSurveyCountAll * 100) / ticketCountAll)}%)` : undefined
                    },
                ];
            }

            return (<SurveyCountSummery showTicketsListPopup={this.showTicketsListPopup} surveySummery={surveySummery1} />);
        }
    }

    getRfcBreakdownNode() {
        const
            {
                rfcBreakdown
            } = this.props;

        if (!rfcBreakdown)
            return <div className="flex justify-content-center" style={{ height: 'inherit', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        let allTickets = rfcBreakdown.map(rb => rb.ticketCount).reduce((a, b) => a + b, 0);
        if (allTickets === 0)
            allTickets = 1;//Avoid deviding by 0

        const colorsToUse = [colors.secandary200, colors.primary200, colors.fourth200];

        let res;
        if (isDefined(this.state.selectedReasonForContact)) {
            res = (<div className="flex-container-column-start">
                <div style={{ width: '27em' }} className="flex-container-end">
                    {this.state.selectedReasonForContact.value}
                </div>
                <div className="flex-container-justify-start-align-center"
                    style={{
                        color: 'white', marginLeft: '10px', padding: '0 10px', height: '34px',
                        backgroundColor: colors.secandary200, width: '600px'
                    }} >
                    100%
                </div>
            </div>)
        }
        else {
            if (!arrayIsNotEmpty(rfcBreakdown)) {
                return <div className="flex justify-content-center" style={{ height: '348px', backgroundColor: 'rgb(252,252,255)' }}>
                    No data for the selected filters
                </div>;
            }
            res = rfcBreakdown.map((rfc, index) => {
                const percentage = parseFloat(100 * rfc.ticketCount / allTickets).toFixed(2);

                if (percentage == 0)
                    return;

                const widthInPx = `${percentage * 12}px`;
                const color = colorsToUse[index % 3];

                return (<div key={index} className="flex-container-column-start">
                    <div style={{ width: '27em' }} className="flex-container-end">
                        {rfc.reasonForContactName}
                    </div>
                    <div className="flex-container-justify-start-align-center"
                        style={{
                            marginLeft: '10px', padding: '0 10px', height: '34px',
                            backgroundColor: color, width: widthInPx
                        }} >
                        {percentage}%
                    </div>
                </div>)
            });
        }
        const graphRfc = (
            <div className="flex-item" style={{ height: '250px', padding: '32px 0' }}>
                {res}
            </div>
        );

        return <div>{graphRfc}</div>
    }

    getChannelBreakdownNode() {
        const
            {
                channelBreakdown
            } = this.props;

        if (!channelBreakdown)
            return <div className="flex justify-content-center" style={{ height: 'inherit', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;

        let channelDataPoints;
        if (isDefined(this.state.selectedChannel)) {
            channelDataPoints = [{
                label: this.state.selectedChannel.value,
                value: 100
            }]
        }
        else {
            if (!arrayIsNotEmpty(channelBreakdown)) {
                return <div className="flex justify-content-center" style={{ height: '348px', backgroundColor: 'rgb(252,252,255)' }}>
                    No data for the selected filters
                </div>;
            }
            else {
                const allTickets = channelBreakdown.map(rb => rb.ticketCount).reduce((a, b) => a + b, 0);
                channelDataPoints = channelBreakdown.map(r => {
                    return {
                        label: r.channelName,
                        value: Math.round(100 * r.ticketCount / allTickets)
                    };
                });
            }
        }

        const graphChannel = (
            <div className="flex-item" style={{ height: '250px', padding: '32px 0' }}>
                {/*<div style={{ justifyContent: 'center' }} className="agent-bottom-panel-title">Channels</div>*/}
                <PieChart propId="pieChart5" dataPoints={channelDataPoints} />
            </div>
        );

        return <div>{graphChannel}</div>
    }

    getResponseBreakdownNode() {
        const
            {
                responseBreakdown,
                isDownloadingReport,
                currentUser
            } = this.props;

        if (!responseBreakdown)
            return <div className="flex justify-content-center" style={{ height: 'inherit', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;

        var surveyQuestionIds = responseBreakdown.surveyQuestionPotentialResponsesFrequency.map(p => p.surveyQuestionId).filter(getOnlyUnique);

        const charts = surveyQuestionIds.map(surveyQuestionId => {
            const surveyQuestion1ResponseBreakdown = responseBreakdown.surveyQuestionPotentialResponsesFrequency.filter(sf =>
                sf.surveyQuestionId === surveyQuestionId);

            surveyQuestion1ResponseBreakdown.sort((a, b) => a.performanceResponseTypeId - b.performanceResponseTypeId);

            const totalCount = surveyQuestion1ResponseBreakdown.map(rb => rb.responseCount).reduce((a, b) => a + b, 0);
            const questionScore = getScoreOnSurveyQuestion(surveyQuestion1ResponseBreakdown);
            const questionScoreLabel = isDefined(questionScore)
                ? `(Score: ${questionScore}% | Count: ${totalCount.toLocaleString()})`
                : `(Count: ${totalCount})`;

            let responsesToQuestion1DataPoints = surveyQuestion1ResponseBreakdown.map(r => {
                let percentage = totalCount > 0 ? Math.round(100 * r.responseCount / totalCount) : 0;
                if (percentage != 0) {
                    return {
                        label: r.surveyQuestionPotentialResponseValue,
                        value: percentage
                    };
                }
            });
            responsesToQuestion1DataPoints = responsesToQuestion1DataPoints.filter(a => a);

            let colorsSet = getPieChartColorSetByPerformanceIdAndValue(surveyQuestion1ResponseBreakdown);

            const graphQuestion1 = arrayIsNotEmpty(surveyQuestion1ResponseBreakdown) ? (
                <div key={surveyQuestionId} className="flex-item question-response-breakdown-chart">
                    {/*  - ({totalCount} responses) */}
                    <div className="agent-bottom-panel-title" style={{ justifyContent: 'center', fontSize: '14px' }}>
                        {surveyQuestion1ResponseBreakdown[0].surveyQuestionName} {questionScoreLabel}
                    </div>

                    <PieChart
                        colors={colorsSet}
                        propId={surveyQuestion1ResponseBreakdown[0].surveyQuestionName}
                        dataPoints={responsesToQuestion1DataPoints} />
                </div>
            ) : undefined;

            return graphQuestion1;

        });
        const resBreakdownHelp = 'Hybrid Data: \n Combination of your \n jibed agent predictions and your customer responses. If an agent who isn\'t Jibed is selected, this filter will mirror their customer response filter. Customer Responses: Just the responses directly from your customer.All Agents: All of your agent\'s predictions regardless of their Jibe status. If an individual agent is selected, this filter will show you only their predictions.';

        return (<div>
            <div>
                <div className="w-full flex-grow flex justify-between items-center space-x-2"
                    style={{ marginTop: '20px' }}>
                    <div className="flex space-x-2">
                        <div style={{ margin: '3px 20px' }}>
                            <Segmented
                                defaultValue={this.state.selectedSurveyTypeId}
                                onChange={this.setSelectedSurveyTypeId}
                                options={[
                                    { label: "Hybrid Data", value: SurveyType.Calibrator },
                                    { label: "Customer", value: SurveyType.Customer },
                                ]}
                            />
                        </div>
                        {this.state.selectedSurveyTypeId === SurveyType.Calibrator &&
                            <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                <HelpOutline onClick={this.showTeamComparisonHelpPopup} />
                            </div>
                        }
                        {
                            this.state.showTeamComparisonHelpPopup &&
                            <PopupCustomized
                                x={this.state.mouseClickX}
                                y={this.state.mouseClickY}
                                Message={resBreakdownHelp}
                                close={this.closeTeamComparisonHelpPopup} />
                        }
                    </div>
                </div>
            </div>
            <div className="flex-container flex-wrap" >{charts}</div>
        </div>);

    }

    getBreakdownNode() {
        const rfcBreakdownNode = this.getRfcBreakdownNode();
        const channelBreakdownNode = this.getChannelBreakdownNode();
        const responseBreakdownNode = this.getResponseBreakdownNode();

        return (
            <Tabs defaultIndex={0}>
                <TabList className="react-tabs-left react-tabs">
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Response</div>
                        </div>
                    </Tab>
                    {/**/}
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Contact Reason</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Channel</div>
                        </div>
                    </Tab>

                </TabList>
                <TabPanel style={{ height: '348px', position: 'relative', overflow: 'auto' }}>
                    {responseBreakdownNode}
                </TabPanel>
                {/**/}
                <TabPanel style={{ height: '348px', position: 'relative', overflow: 'auto' }}>
                    {rfcBreakdownNode}
                </TabPanel>
                <TabPanel style={{ height: '348px', position: 'relative', overflow: 'auto' }}>
                    {channelBreakdownNode}
                </TabPanel>

            </Tabs >);

    }

    //setBreakdownSelectedView(value) {
    //    this.setState({ breakdownSelectedView: value });
    //}

    setSelectedSurveyTypeId(value) {
        const
            {
                fromDate,
                toDate
            } = this.props;

        this.setState({ selectedSurveyTypeId: value });
        this.props.dispatch(updateProps({ responseBreakdown: undefined }));

        const selectedAgentId = isDefined(this.state.selectedAgent) ? this.state.selectedAgent.id : undefined;

        this.props.dispatch(loadResponseBreakdown(value, fromDate, toDate, this.state.selectedFilters, selectedAgentId));
    }

    onApplyFilters = () => {
        const
            {
                fromDate,
                toDate
            } = this.props;

        const selectedAgentId = isDefined(this.state.selectedAgent) ? this.state.selectedAgent.map(obj => obj.id).join(',') : undefined;

        this.props.dispatch(updateProps({
            ticketCountOverTimeStats: undefined,
        }));

        this.props.dispatch(loadSurveyActivityV3ManagerScreen(fromDate, toDate, this.state.selectedTimePeriodicity,
            this.state.selectedFilters, selectedAgentId, this.state.selectedSurveyTypeId));
    }

    getInteractionsReport() {
        const
            {
                fromDate,
                toDate
            } = this.props;

        this.props.dispatch(loadInteractionsReport(fromDate, toDate));
    }

    getCustomerInteractionsReport() {
        const
            {
                fromDate,
                toDate
            } = this.props;
        this.props.dispatch(updateProps({ isDownloadingReport: true }));
        this.props.dispatch(loadCustomerInteractionsReport(fromDate, toDate));
    }

    getCustomerInteractionsReportBySurveyDate() {
        const
            {
                fromDate,
                toDate
            } = this.props;
        this.props.dispatch(updateProps({ isDownloadingReport: true }));
        this.props.dispatch(loadCustomerInteractionsReportBySurveyDate(fromDate, toDate));
    }

    render() {
        const
            {
                ticketCountOverTimeStats,
                progressOverTimeStatsByTeam,
                allInteractions,
                currentUser,
                calibratedOnSurveyQuestions,
                userTeamsStats,
                fromDate,
                toDate,
                isDownloadingReport
            } = this.props;
        if (!currentUser) {
            return <div>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="250" />
            </div>;
        }
        if (currentUser.RoleId == ZRole.Agent) {
            return <SurveyActivityV3AgentScreen />
        }

        const surveyCountSummaryNode = this.getSurveyCountSummaryNode();
        const breakdownNode = this.getBreakdownNode();
        const timeRangesNode = this.getFilters();

        return (
            <div className="main-page-width">
                {timeRangesNode}
                <div style={{
                    margin: '0 0 20px 0',
                    boxShadow: '0px 1px 25px rgb(0 0 0 / 24%)',
                    borderRadius: '24px'
                }}>
                    <div>
                        {isDownloadingReport && <LoadingControl />}
                        {!isDownloadingReport &&
                            <div className="flex" style={{ padding: '20px' }}>
                                <div className="export-button" onClick={() => this.getInteractionsReport()}>
                                    <div className="export-button-text">Export Agent Predictive Surveys</div>
                                    <ExportIcon />
                                </div>
                                {currentUser.ClientId !== clientIdNumber.Rockstar &&
                                    <div className="export-button" onClick={() => this.getCustomerInteractionsReport()}>
                                        <div className="export-button-text">Export Customer Surveys</div>
                                        <ExportIcon />
                                    </div>
                                }
                                {currentUser.ClientId === clientIdNumber.Rockstar &&
                                    <div className="flex">
                                        <div className="export-button" onClick={() => this.getCustomerInteractionsReport()}>
                                            <div className="export-button-text">Export Customer Surveys By Ticket Date</div>
                                            <ExportIcon />
                                        </div>
                                        <div className="export-button" onClick={() => this.getCustomerInteractionsReportBySurveyDate()}>
                                            <div className="export-button-text">Export Customer Surveys By Survey Date</div>
                                            <ExportIcon />
                                        </div>
                                    </div>
                                }
                            </div>}
                    </div>
                    <div className="flex-container">
                        {surveyCountSummaryNode}
                    </div>

                    <hr />
                    <div>
                        {breakdownNode}
                    </div>
                </div>
                <TeamsCompareAndOverTimeGraphs
                    fromDate={fromDate}
                    toDate={toDate}
                    userTeamsStats={userTeamsStats}
                    selectedTeam={this.state.selectedTeam}
                    progressOverTimeStats={ticketCountOverTimeStats}
                    progressOverTimeStatsByTeam={progressOverTimeStatsByTeam} />
                {this.state.showTicketsListPopup &&
                    <TicketsListModal
                        fromDate={fromDate}
                        toDate={toDate}
                        onDownloadReport={this.getInteractionsReport}
                        calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                        onSelectNewTimeRange={this.onSelectNewTimeRangeForTickets}
                        allInteractions={allInteractions}
                        onClose={this.closeTicketsListPopup} />}

            </div >);
    }
}

const select = state => ({ ...state.SurveyActivityScreen, ...state.session });

export default connect(select)(SurveyActivityV3ManagerScreen);